import {SET_IsSystemManager} from "@/store/mutation-types";

const TAG = "[store.modules.permission]"


const state = {
  routes: [],
  sideBarItems:null,
  devMode:false,
  isSystemManager:false,
  abc:"abc"
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  },
  SET_SIDE_BAR_ITEMS: (state, sideBarItems) => {
    state.sideBarItems = sideBarItems
  },
  SET_IsSystemManager: (state, value) => {
    state.isSystemManager = value
  },
  SET_DEV_MODE: (state, value) => {
    state.devMode = value
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js